import React, { FC, Fragment, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { newsSelectors } from '@ucheba/store/institutions/news'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { useRouter } from 'next/router'
import { authSelectors } from '@ucheba/store/auth'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { Banner } from '../../../../../../components/Banner/desktop'
import NewsItem from '../../../../components/NewItem/desktop'
import Pagination from '../../../../components/Pagination/desktop'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import { EActivityInfoPart } from '../../../../../../components/InstitutionExams/types'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const NewsList: FC = () => {
  const news = useSelector(newsSelectors.entity)
  const router = useRouter()
  const isAuth = useSelector(authSelectors.isAuth)
  const {
    query: { id: instId },
  } = router
  const { setUserActivity } = useUserActivity()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId: Array.isArray(instId) ? Number(instId[0]) : Number(instId),
      data: { infoPart: EActivityInfoPart.news },
    })
  }

  const { extraParams, paidPackage } = useBannerProgramTypes()

  const showBanner = useCallback(
    (index: number) => {
      if (!isPaidPackage(paidPackage) && news?.items && news?.items?.length < 3) {
        return news.items.length - 1 === index
      }
      if (!isPaidPackage(paidPackage) && news?.items) {
        return index === 2
      }
      return false
    },
    [news, paidPackage]
  )

  return (
    <>
      <LimitedList
        onShowAll={handleShowAllClick}
        isAuth={isAuth}
        id='news'
        items={news.items}
        buttonText='Показать все новости'
        limit={isAuth ? undefined : 5}
        showAllButtonLinkIsLink={false}
      >
        {({ limitedItems, isOpen }) => {
          return (
            <>
              <List spacing='null'>
                {limitedItems.map(({ id, dateCreated, title, institutionId }, index) => {
                  const isDivider = true

                  return (
                    <Fragment key={id}>
                      <NewsItem
                        isDivider={isDivider}
                        title={title}
                        dateCreated={dateCreated}
                        path={`/uz/${institutionId}/news/${id}`}
                      />

                      {showBanner(index) && (
                        <ListItem>
                          <Banner extraParams={extraParams} id={2} />
                        </ListItem>
                      )}
                    </Fragment>
                  )
                })}
              </List>

              {news.total > 15 && isOpen && (
                <>
                  <Divider />

                  <Pagination
                    total={news?.total}
                    showItemsCount={15}
                    totalCount={`${news?.total} ${p11n(
                      news?.total || 0,
                      'новость',
                      'новости',
                      'новостей'
                    )}`}
                  />
                </>
              )}
            </>
          )
        }}
      </LimitedList>

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default NewsList
